import axios from 'axios'
import { DATAMASTER_ENDPOINT } from '../../endpoints'

export async function putAssignCodia(body) {
  let result = ''
    try {
      result = await axios.put(`${DATAMASTER_ENDPOINT}/assign/codia`,body)
    } catch (error) {
      result = error.message
    }
    return result
  }

